/* Bradford Sports · scroll reveal (progressive enhancement).
   Sections mark elements with .bs-reveal. Nothing is hidden until this script
   confirms it is running (html.bs-js), so a JS failure never hides a section. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  document.documentElement.classList.add('bs-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  var arm = function () {
    document.querySelectorAll('.bs-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  };
  arm();
  document.addEventListener('shopify:section:load', arm);
  document.addEventListener('shopify:section:reorder', arm);
})();

/* Bradford Sports · one founding number per order.
   A Golf Club number is a seat, not merchandise — two in one cart would sell the
   same seat twice. Shopify has no per-order limit outside B2B, so the theme holds
   the line: the quantity field is pinned to 1 on that product page, and any cart
   line that still climbs above 1 is corrected before checkout. */
(function () {
  var LIMITED = 'bgc-founding-number';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var correcting = false;

  function isLimitedPage() {
    return window.location.pathname.indexOf('/products/' + LIMITED) !== -1;
  }

  /* Dawn's <quantity-input> rewrites min/max from its own rules after we run, so
     the pin is re-applied on the events that trigger that rewrite rather than once. */
  function pinQuantity() {
    if (!isLimitedPage()) return;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = '1';
      input.setAttribute('min', '1');
      input.setAttribute('max', '1');
      input.readOnly = true;
      var wrap = input.closest('quantity-input') || input.parentElement;
      if (!wrap) return;
      wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    });
  }

  function repin() {
    pinQuantity();
    setTimeout(pinQuantity, 300);
  }

  function correctCart() {
    if (correcting) return;
    correcting = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var over = (cart.items || []).filter(function (i) {
          return i.handle === LIMITED && i.quantity > 1;
        })[0];
        if (!over) { correcting = false; return; }
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: over.key, quantity: 1 })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { correcting = false; });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) correctCart();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    repin();
    watchDrawer();
    if (isLimitedPage()) {
      document.addEventListener('change', repin);
      document.addEventListener('variant:change', repin);
    }
    if (window.location.pathname.indexOf('/cart') === 0) correctCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', repin);
})();
